import RiskGuidelinesTab from "./RiskAndGuidelinesTab";
export default RiskGuidelinesTab;
